import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import HeaderNavigation from './HeaderNavigation';
import HeaderSearch from './HeaderSearch';

const Header = ({ bt, isMobile, path }) => {
  const [navigation] = useSelector((state) => [state.navigation.list || []]);
  const HeaderTop = dynamic(() => import('./HeaderTop'), {
    ssr: true,
  });
  const HeaderTopMobile = dynamic(() => import('./HeaderTopMobile'), {
    ssr: true,
  });
  const HeaderLogo = dynamic(() => import('./HeaderLogo'), {
    ssr: true,
  });
  const HeaderButtons = dynamic(() => import('./HeaderButtons'), {
    ssr: true,
  });

  return (
    <>
      <header className="header">
        <div className="items">
          <div className="header-container">
            <div className="no-gutters">
              <div className="top-container">
                {!isMobile && <HeaderTop />}
                {isMobile && (
                  <HeaderTopMobile
                    bt={bt}
                    navigation={navigation}
                    path={path}
                  />
                )}
              </div>

              <div className="row align-items-center items-container">
                {!isMobile && <HeaderLogo />}
                <HeaderSearch />
                {!isMobile && <HeaderButtons bt={bt} />}
              </div>
            </div>
          </div>
        </div>

        <HeaderNavigation isMobile={isMobile} navigation={navigation} />
      </header>
      <style jsx>{`
        .header {
          position: ${isMobile ? 'sticky' : 'static'};
          top: 0;
          z-index: 1020;
        }
        .header-container {
          -webkit-box-align: stretch;
          -webkit-box-pack: justify;
          align-items: stretch;
          display: flex;
          flex-flow: wrap;
          justify-content: space-between;
          margin-bottom: -20px;
          margin-left: auto;
          margin-right: auto;
          max-width: 1200px;
          padding-left: ${isMobile ? '10px' : '15px'};
          padding-right: ${isMobile ? '10px' : '15px'};
          width: 100%;
        }
        .items {
          background-color: #fff;
          min-height: 105px;
        }
        .no-gutters {
          width: 100%;
        }
        .top-container {
          min-height: ${isMobile ? '41px' : '27px'};
        }
        .items-container {
          margin-top: ${isMobile ? '0' : '10px'};
        }
      `}</style>
    </>
  );
};

Header.propTypes = {
  bt: PropTypes.string,
  isMobile: PropTypes.bool,
  path: PropTypes.string,
};

export default Header;
